<template>
  <div>
    <v-checkbox label="Assina CCB" v-model="assinaCCB" @change="retiraPapeis" v-if="!!nomeConjuge" />
    <input-multiselect v-model="model" :options="papeis" label="Papéis" :required="!nomeConjuge || assinaCCB" :disabled="!assinaCCB && !!nomeConjuge" />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object,
  },
  data () {
    return {
      proposta: null,
      listBase: [],
      assinaCCB: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis: {
      get () {
        return this.$param.EST_PAPEIS.map(el => {
          return {
            text: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal).toUpperCase(),
            value: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal).toUpperCase(),
          }
        })
      },
    },
  },
  methods: {
    async submit () {
      const th = this;
      const assinante = th.assinante
      if (!th.assinaCCB) {
        th.model = []
      }

      let arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];
      const arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      if (arrayExclusao.length > 0) {
        await th.removerAssinantes();
      }

      if (arrayInclusao.length > 0) {
        arrayInclusao = arrayInclusao.map(papel => {
          return {
            CodigoProposta: th.codigoProposta,
            Nome: th.nomeConjuge ? `${assinante.Nome} - CÔNJUGE DE ${th.nomeConjuge}` : assinante.Nome,
            Email: assinante.Email,
            Documento: assinante.DocumentoFederal,
            TelefoneCelular: assinante.TelefoneCelular,
            Descricao: papel,
            NotificarPorEmail: true,
            EnviarNotificacaoEmail: true,
          }
        })
        th.$api.Multiplo.InsertCCBDigitalAssinaturas({ dto: arrayInclusao }).then(resInsert => {
          if (th.$api.UI.PostLoadData(resInsert, true)) { };
        });
      }
    },
    carregarAssinantes () {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: th.codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.ListCCBDigitalAssinatura(dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => el.Documento === th.$api.UI.Format.SomenteAlfanumerico(th.assinante.DocumentoFederal)));
          th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
          if (th.listBase.length > 0) th.assinaCCB = true;
        }
      });
    },
    retiraPapeis () {
      const th = this;
      if (!th.assinaCCB) {
        th.model = []
      } else {
        th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
      }
    },
    async removerAssinantes () {
      const th = this;
      th.assinaCCB = false;
      th.model = {};

      let arrayExclusao = Array.isArray(th.listBase) ? [...th.listBase] : [];

      arrayExclusao = arrayExclusao.map(papel => {
        return papel.Codigo
      })

      await th.$api.Multiplo.RemoveCCBDigitalAssinaturas({ dto: arrayExclusao });
    }
  },
}
</script>
